import { ParamExUr } from "../Consultation/types";

export const normalizeParamExUrList = (input: unknown): ParamExUr[] => {
  const raw = Array.isArray(input) ? input : [];
  const mapped: ParamExUr[] = raw.map((p: any, idx: number) => ({
    idParam: Number(p?.idParam ?? p?.IdParam ?? 0),
    idCons: Number(p?.idCons ?? p?.IdCons ?? 0),
    denumire: String(p?.denumire ?? p?.Denumire ?? ""),
    valoare: String(p?.valoare ?? p?.Valoare ?? ""),
    pozitie: Number(p?.pozitie ?? p?.Pozitie ?? idx + 1),
    tip: Number(p?.tip ?? p?.Tip ?? 0),
    valoareMinimala: String(p?.valoareMinimala ?? p?.ValoareMinimala ?? ""),
    valoareMaximala: String(p?.valoareMaximala ?? p?.ValoareMaximala ?? ""),
  }));

  const sorted = [...mapped].sort((a, b) => {
    const pa = Number.isFinite(a.pozitie) ? a.pozitie : 0;
    const pb = Number.isFinite(b.pozitie) ? b.pozitie : 0;
    return pa - pb;
  });

  // Keep pozitie consistent with the rendered order.
  return sorted.map((p, idx) => ({ ...p, pozitie: idx + 1 }));
};
